import { render, staticRenderFns } from "./ClaimReportConfirm.vue?vue&type=template&id=fbbb8a48"
import script from "./ClaimReportConfirm.vue?vue&type=script&lang=js"
export * from "./ClaimReportConfirm.vue?vue&type=script&lang=js"
import style0 from "./ClaimReportConfirm.vue?vue&type=style&index=0&id=fbbb8a48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports